<h1 mat-dialog-title>{{ fortbildung?.titel }}: Teilnehmer hinzufügen</h1>
<mat-dialog-content style="overflow-y: hidden; max-width: 500px">
    <kiene-autocomplete
        [apiUrl]="apiBaseUrl + 'benutzer/'"
        [params]="params"
        [displayFields]="['vorname', 'nachname']"
        [separator]="' '"
        [panelWidth]="'450px'"
        [clearAfterSelect]="true"
        [placeholder]="'Teilnehmer suchen'"
        (elementSelected)="addTeilnehmer($event)"
    >
    </kiene-autocomplete>

    <mat-chip-list style="margin-bottom: 24px; max-width: 500px">
        <mat-chip
            *ngFor="let teilnehmer of fortbildung.teilnehmer"
            [selectable]="true"
            [removable]="true"
            (removed)="removeTeilnehmer(teilnehmer)"
        >
            {{ teilnehmer.vorname }} {{ teilnehmer.nachname }}
            <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
    </mat-chip-list>
</mat-dialog-content>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-button (click)="dialogRef.close()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()">Speichern</button>
</div>
